import { gql } from "@apollo/client";

export const MUTATION_HAS_PURCHASE_BEEN_VERIFIED = gql`
  mutation HasPurchaseBeenVerified(
    $paymentAttempt: PaymentAttempt
    $networkName: String
  ) {
    hasPurchaseBeenVerified(paymentAttempt: $paymentAttempt, networkName: $networkName) {
      id
      cardId
      offerId
      barCodeImageUrl
      barCodeType
      cardNumber
      cardPin
      createdAt
      reloadHistory {
        amount {
          fiat {
            value
          }
        }
        totalSaleAmount
        btcVoucherDetails {
          btcVoucherUserAmount
        }
        giftDetails {
          name
          emailAddress
          message
        }
      }
      offer {
        id
        offerId
        brandName
        networkName
        barCodeType
        presetAmounts
        instruction {
          locale
          text
        }
        productDescription {
          locale
          text
        }
        termsAndConditions {
          inAppCard {
            locale
            text
          }
        }
        reloadSettings {
          isReloadable
        }
        commissionSettings {
          grossCommissionAmount
          memberRewardAmount
          isPercentage
        }
        styleSettings {
          includeImageBorder
          isCustomImageUpload
        }
        images {
          imageUrl
        }
      }
    }
  }
`;
